import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "card mb-25 border-0 rounded-0 bg-white checkout-box letter-spacing" }
const _hoisted_3 = { class: "card-body col-12" }
const _hoisted_4 = {
  class: "nav nav-tabs bg-white border-0 rounded-0",
  id: "myTab",
  role: "tablist"
}
const _hoisted_5 = ["aria-selected", "onClick"]
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-6" }
const _hoisted_8 = { class: "col-12" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "form-group col-6" }
const _hoisted_11 = { class: "input-group" }
const _hoisted_12 = { class: "form-group col-6" }
const _hoisted_13 = { class: "input-group" }
const _hoisted_14 = { class: "row" }
const _hoisted_15 = { class: "col-6" }
const _hoisted_16 = { class: "col-6" }
const _hoisted_17 = { class: "row justify-content-left p-3" }
const _hoisted_18 = { class: "card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto" }
const _hoisted_19 = { class: "card-body shift-card-body" }
const _hoisted_20 = { class: "align-items-center" }
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "product-details-content" }
const _hoisted_23 = { class: "info ps-0 list-unstyled d-inline-block" }
const _hoisted_24 = { class: "text-para fs-md-15 fs-xxxl-16" }
const _hoisted_25 = { class: "overView-value" }
const _hoisted_26 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_27 = { class: "text-paragraph fs-md-15 fs-xxxl-16" }
const _hoisted_28 = { class: "col-sm-6 col-12 maximum-graph-size" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EvidencePieGraph = _resolveComponent("EvidencePieGraph")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("ul", _hoisted_4, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.overViewData.productList, (item, index) => {
              return (_openBlock(), _createElementBlock("li", {
                key: item.productName,
                class: "nav-item",
                role: "tablist"
              }, [
                _createElementVNode("button", {
                  class: _normalizeClass(['nav-link fs-14 fs-md-15 fs-lg-16 fw-semibold position-relative border-0 rounded-0 d-block w-100', { active: (index==_ctx.selectedProductIndex)?true:false }]),
                  role: "button",
                  "aria-selected": (index==_ctx.selectedProductIndex)?true:false,
                  onClick: ($event: any) => (_ctx.selectProduct(index))
                }, _toDisplayString(item.text), 11, _hoisted_5)
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, [
                    _cache[10] || (_cache[10] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 text-muted" }, [
                      _createElementVNode("i", { class: "flaticon-calendar lh-1 position-relative top-1" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.borderDates.startDate) = $event)),
                      onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.setCustomDateSelection && _ctx.setCustomDateSelection(...args))),
                      type: "date",
                      class: "form-control shadow-none rounded-0 text-black me-1"
                    }, null, 544), [
                      [_vModelText, _ctx.borderDates.startDate]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _cache[11] || (_cache[11] = _createElementVNode("span", { class: "input-group-text rounded-0 fs-14 text-muted" }, [
                      _createElementVNode("i", { class: "flaticon-calendar lh-1 position-relative top-1" })
                    ], -1)),
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.borderDates.endDate) = $event)),
                      onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.setCustomDateSelection && _ctx.setCustomDateSelection(...args))),
                      type: "date",
                      class: "form-control shadow-none rounded-0 text-black me-1"
                    }, null, 544), [
                      [_vModelText, _ctx.borderDates.endDate]
                    ])
                  ])
                ])
              ]),
              _createElementVNode("span", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _cache[13] || (_cache[13] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Časové období:", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.timeSelected) = $event)),
                    onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.changeBorderDates(_ctx.timeSelected))),
                    class: "form-select shadow-none fw-semibold rounded-0 col-6"
                  }, [...(_cache[12] || (_cache[12] = [
                    _createStaticVNode("<option value=\"day\" data-v-3816be74>Dnes</option><option value=\"week\" data-v-3816be74>Týden</option><option value=\"month\" data-v-3816be74>Měsíc</option><option value=\"30days\" data-v-3816be74>30 dní</option><option value=\"60days\" data-v-3816be74>60 dní</option><option value=\"90days\" data-v-3816be74>90 dní</option><option value=\"120days\" data-v-3816be74>120 dní</option><option value=\"custom\" data-v-3816be74>Vlastní</option>", 8)
                  ]))], 544), [
                    [_vModelSelect, _ctx.timeSelected]
                  ])
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _cache[15] || (_cache[15] = _createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, "Typ licence", -1)),
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.licenseSelected) = $event)),
                    onChange: _cache[7] || (_cache[7] = ($event: any) => (_ctx.getNewData())),
                    class: "form-select shadow-none fw-semibold rounded-0 col-6"
                  }, [...(_cache[14] || (_cache[14] = [
                    _createElementVNode("option", { value: "FULL" }, "FULL", -1),
                    _createElementVNode("option", { value: "DEMO" }, "DEMO", -1),
                    _createElementVNode("option", { value: "TRIAL" }, "TRIAL", -1)
                  ]))], 544), [
                    [_vModelSelect, _ctx.licenseSelected]
                  ])
                ])
              ])
            ]),
            _createElementVNode("span", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("div", _hoisted_21, [
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("ul", _hoisted_23, [
                          _createElementVNode("li", _hoisted_24, [
                            _cache[16] || (_cache[16] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Počet otevřených evidencí: ", -1)),
                            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.statisticsData.totalEvidenceCount), 1)
                          ]),
                          _createElementVNode("li", _hoisted_26, [
                            _cache[17] || (_cache[17] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Nejčastější unikátní evidence: ", -1)),
                            _createElementVNode("a", {
                              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.redirectToEvidence(_ctx.statisticsData.mostFrequentUniqueEvidence, _ctx.overViewData.productList[_ctx.selectedProductIndex].value))),
                              class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none",
                              href: "javascript:void(0);"
                            }, _toDisplayString(_ctx.capitalizeString(true, _ctx.statisticsData.mostFrequentUniqueEvidence)), 1)
                          ]),
                          _createElementVNode("li", _hoisted_27, [
                            _cache[18] || (_cache[18] = _createElementVNode("span", { class: "text-black fw-semibold d-inline-block" }, "Nejčastější evidence: ", -1)),
                            _createElementVNode("a", {
                              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.redirectToEvidence(_ctx.statisticsData.mostFrequentEvidence, _ctx.overViewData.productList[_ctx.selectedProductIndex].value))),
                              class: "d-inline-block fs-md-15 fs-lg-16 text-primary text-decoration-none",
                              href: "javascript:void(0);"
                            }, _toDisplayString(_ctx.capitalizeString(true, _ctx.statisticsData.mostFrequentEvidence)), 1)
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _cache[19] || (_cache[19] = _createElementVNode("div", { class: "card mb-25 ml-1 border-0 rounded-0 bg-white letter-spacing col-auto" }, [
                _createElementVNode("div", { class: "card-body shift-card-body" }, [
                  _createElementVNode("div", { class: "align-items-center" })
                ])
              ], -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_28, [
            _createVNode(_component_EvidencePieGraph, {
              graphData: _ctx.evidenceOverviewList,
              borderDates: _ctx.borderDates
            }, null, 8, ["graphData", "borderDates"])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", null, [
      _createVNode(_component_DataTable, {
        tableData: _ctx.tableData,
        tableOptions: _ctx.tableOptions,
        onTableRestrictionChange: _ctx.handleTableRestrictionChange,
        ref: "tableDataRef"
      }, null, 8, ["tableData", "tableOptions", "onTableRestrictionChange"])
    ])
  ]))
}